var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatEditi = function SvgChatEditi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M7.912 16.5a.46.46 0 0 1-.3-.119.41.41 0 0 1-.107-.33l.205-1.8a.33.33 0 0 1 .113-.246l4.6-4.578a.36.36 0 0 1 .289-.119.37.37 0 0 1 .281.119l1.6 1.6a.39.39 0 0 1 0 .57l-4.666 4.648a.38.38 0 0 1-.26.121l-1.719.137zm.584-2.029-.119 1.176 1.08-.086 4.256-4.256-1.025-1.023zm6.391-3.754-1.605-1.6a.38.38 0 0 1-.127-.289.4.4 0 0 1 .127-.285l.91-.918a.4.4 0 0 1 .576 0l1.605 1.609a.38.38 0 0 1 .127.289.4.4 0 0 1-.127.287l-.91.908a.4.4 0 0 1-.287.129.41.41 0 0 1-.289-.132z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatEditi);
export default ForwardRef;